import { useSignUpUser } from "@/features/user/hooks/use-sign-up-user";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const SignUpUser = () => {
  type PageState = {
    token: string;
    password: string;
  }
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as PageState | null;
  useEffect(() => {
    if (!state || !state.token || !state.password) {
      navigate(EndpointPathNames.ERROR, { replace: true });
    }
  }, [state]);

  const {
    userName,
    userNameError,
    onChangeUserName,
    onClickNext,
  } = useSignUpUser();

  if (!state || !state.token || !state.password) {
    return null; // エラー遷移するまで描画しない
  }

  // ユーザー名フォームに付与するID
  const userNameFormId = "user_name_form_id";
  // 次へボタンに付与するID
  const nextButtonId = "next_button_id";
  // 戻るボタンに付与するID
  const returnButtonId = "return_button_id";

  return (
    <>
      <LoginHeader content="新しいアカウントを作成" />
      <main>
        <section id="signUp">
          <nav className="step">
            <ol>
              <li className="done">仮登録メールを送信</li>
              <li className="done">パスワードの設定</li>
              <li className="active">ユーザー名の設定</li>
              <li>登録完了</li>
            </ol>
          </nav>
          <p>ユーザー名を設定してください</p>
          <ul className="form">
            <li>
              <SimpleForm
                onChange={onChangeUserName}
                id={userNameFormId}
                errorMessage={userNameError}
                title="ユーザー名"
                labelEnable={true}
              />
            </li>
          </ul>
          <div className="notice">
            <p>ユーザー名はアカウント名を表示しなければならない場合に、セキュリティ上のトラブルを回避するための項目です。この項目は後からでも設定できます。</p>
          </div>
          <nav className="btns">
            <span style={{ marginRight: "0.5rem"}}>
              <BaseRoundButton
                id={returnButtonId}
                buttonText="戻る"
                onClick={() => navigate(-1)}
                className="btn-base"
              />
            </span>
            <BaseRoundButton
              id={nextButtonId}
              buttonText="次へ"
              onClick={() => onClickNext(state.token, state.password, userName)}
              className="nav-main"
              isActive={userName !== ""}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
